import { render, staticRenderFns } from "./loanReviewList.vue?vue&type=template&id=6520182a&scoped=true&"
import script from "./loanReviewList.vue?vue&type=script&lang=js&"
export * from "./loanReviewList.vue?vue&type=script&lang=js&"
import style0 from "./loanReviewList.vue?vue&type=style&index=0&id=6520182a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520182a",
  null
  
)

export default component.exports